var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"doc"},[_c('div',[_vm._v(" 联合信任平台删除所有协议和说明文件中涉及“联合信任享有最终解释权”的条款，除此外上述协议和说明文件无其他修改。 ")]),_c('div',[_c('span',{staticClass:"blue",staticStyle:{"cursor":"pointer"},on:{"click":_vm.goNext}},[_vm._v("《用户注册与使用协议》")]),_vm._v("删除了原版本的最后一条，请查看并确认。 ")]),_c('div',[_vm._v(" 如对本次平台协议或文件的修改有任何疑问、意见或建议，用户可通过联合信任平台提供的各种联系方式与联合信任联系。 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }